<template>
  <div>
    <!-- <loading
      v-show="isLoading"
      :active="true"
      :is-full-page="true"
      color="#498ceb"
    /> -->

    <b-card>
      <b-row>
        <b-col
          v-if="hasPermission('privacy-treatment', 'create')"
          md="3"
          class="mb-1"
        >
          <b-button
            variant="outline-primary"
            :to="{ name: 'privacy-treatment-add' }"
          >
            <feather-icon
              icon="PlusIcon"
              class="mr-50"
            />
            {{ $t('Agregar Tratamiento') }}
          </b-button>
        </b-col>

        <b-col
          v-if="hasPermission('privacy-treatment', 'export')"
          md="2"
          class="mb-1"
        >
          <b-button
            variant="outline-success"
            :disabled="!treatments.length"
            @click="handleExportExcel"
          >
            <feather-icon
              icon="DownloadIcon"
              class="mr-50"
            />
            {{ $t('Export Excel') }}
          </b-button>
        </b-col>

        <b-col
          v-if="hasPermission('privacy-treatment', 'create')"
          md="2"
          class="mb-1"
        >
          <b-button
            variant="outline-info"
            v-b-modal.import-rat-modal
          >
            <feather-icon
              icon="UploadIcon"
              class="mr-50"
            />
            {{ $t('Import Excel') }}
          </b-button>
        </b-col>

        <b-col md="2" class="mb-1">
          <b-button
            variant="outline-secondary"
            :disabled="clearFiltersDisabled"
            @click="clearFilters"
          >
            <feather-icon
              icon="TrashIcon"
              class="mr-50"
            />
            {{ $t('clear_filters') }}
          </b-button>
        </b-col>

        <b-col :md="canImport ? 3 : 5">
          <b-form-group>
            <b-form-input
              v-model="searchQuery"
              :placeholder="$t('message.search')"
              type="search"
              class="d-inline-block"
            />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col>
          <filters
            :locationFilterShow="true"
            :rolPrivacyFilterShow="true"
            :volumenFilterShow="true"
            :ambitoFilterShow="true"
            :sensiblesFilterShow="true"
            :transferenciaFilterShow="true"
            @changeFilter="updateFilter"
          />
        </b-col>
      </b-row>

      <b-row>

        <b-col cols="12">
          <b-table
            ref="refTreatmentTable"
            :items="treatments"
            hover
            responsive
            :fields="tableColumns"
            primary-key="_id"
            :sort-by.sync="sortBy"
            show-empty=""
            :empty-text="isLoading ? $t('message.loading') : $t('message.no_records')"
            :sort-desc.sync="isSortDirDesc"
          >
            <template #cell(treatmentId)="data">
              <span class="font-weight-bold">{{ data.item.treatmentId }}</span>
            </template>

            <template #cell(rol)="data">
              <span>{{ data.item.rolComputed.value }}</span>
            </template>

            <template #cell(hasSensitive)="data">
              <b-badge :variant="data.item.hasSensitive ? 'warning' : 'secondary'">
                {{ data.item.hasSensitive ? 'Sí' : 'No' }}
              </b-badge>
            </template>

            <template #cell(hasMinors)="data">
              <b-badge :variant="data.item.hasMinors ? 'warning' : 'secondary'">
                {{ data.item.hasMinors ? 'Sí' : 'No' }}
              </b-badge>
            </template>

            <template #cell(hasBiometric)="data">
              <b-badge :variant="data.item.hasBiometric ? 'warning' : 'secondary'">
                {{ data.item.hasBiometric ? 'Sí' : 'No' }}
              </b-badge>
            </template>

            <template #cell(actions)="data">
              <div class="flex flex-column">
                <EditButton
                  v-if="hasPermission('privacy-treatment', 'edit')"
                  @clicked="router.push({name: 'privacy-treatment-edit', params: { id: data.item._id }})"
                />
                <DuplicateButton
                  v-if="hasPermission('privacy-treatment', 'create')"
                  v-b-modal="`duplicate modal ${data.item._id}`"
                />
                <b-modal
                  v-if="hasPermission('privacy-treatment', 'create')"
                  :id="`duplicate modal ${data.item._id}`"
                  centered
                  no-close-on-backdrop
                  modal-class="modal-info"
                  ok-variant="info"
                  cancel-variant="outline-secondary"
                  :title="$t('message.confirm_action')"
                  :ok-title="$t('Duplicate')"
                  :cancel-title="$t('message.cancel')"
                  @ok="duplicateTreatment(data.item)"
                >
                  {{ $tc('message.confirm_duplicate_treatment', 0, { treatment: data.item.nombre }) }}
                </b-modal>
                <DeleteButton v-if="hasPermission('privacy-treatment', 'delete')" v-b-modal="`delete modal ${data.item._id}`"/>
                <b-modal
                  v-if="hasPermission('privacy-treatment', 'delete')"
                  :id="`delete modal ${data.item._id}`"
                  centered
                  no-close-on-backdrop
                  modal-class="modal-danger"
                  ok-variant="danger"
                  cancel-variant="outline-secondary"
                  :title="$t('message.confirm_action')"
                  :ok-title="$t('message.delete')"
                  :cancel-title="$t('message.cancel')"
                  @ok="deleteTreatment(data.item)"
                >
                  <span>{{ $tc('message.confirm_delete_treatment', 0, { treatment: data.item.nombre }) }}</span>
                  <p v-if="data.item.relatedCount > 0" class="text-danger font-weight-bold mt-1 mb-0">
                    {{ $t('Advertencia: Este tratamiento tiene') }} {{ data.item.relatedCount }} {{ $t('evaluaciones asociadas (ARI/ARR). Todos serán eliminados permanentemente.') }}
                  </p>
                </b-modal>
              </div>
            </template>
          </b-table>
        </b-col>

        <b-col
          cols="12"
          class="d-flex justify-content-between flex-wrap"
        >
          <div class="mb-1">
            <b-form-group class="mb-0">
              <label class="d-inline-block text-sm-left mr-50">{{ $t('message.per_page') }}</label>
              <b-form-select
                id="perPageSelect"
                v-model="perPage"
                size="sm"
                :options="[10, 25, 50, 100]"
                class="w-50"
              />
            </b-form-group>
          </div>

          <div class="mb-1">
            <span class="text-muted">{{ $tc('message.paginationText', 0, { from: `${((currentPage * perPage) - perPage) + (treatments.length ? 1 : 0)}`, to: `${treatments.length + ((currentPage * perPage) - perPage)}`, total: `${totalTreatments}` }) }}</span>
          </div>

          <b-pagination
            v-model="currentPage"
            :total-rows="totalTreatments"
            :per-page="perPage"
            first-number=""
            last-number=""
            prev-class="prev-item"
            next-class="next-item"
          />
        </b-col>
      </b-row>
    </b-card>

    <!-- Import Modal -->
    <import-r-a-t-modal
      modal-id="import-rat-modal"
      @import-success="handleImportSuccess"
    />
  </div>
</template>

<script>
import { BBadge, BPagination, BTable, BModal, VBModal } from 'bootstrap-vue'
import { computed, onMounted } from '@vue/composition-api'
import { useRouter } from '@core/utils/utils'
import { hasPermission } from '@/composables/usePermission'
import EditButton from '@/views/components/Shared/Buttons/EditButton.vue'
import DeleteButton from '@/views/components/Shared/Buttons/DeleteButton.vue'
import DuplicateButton from '@/views/components/Shared/Buttons/DuplicateButton.vue'
import Filters from '@/views/organization/Filters.vue'
import ImportRATModal from './ImportRATModal.vue'
import useTreatmentList from './useTreatmentList'
import useExportRAT from './useExportRAT'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import Ripple from 'vue-ripple-directive'

export default {
  components: {
    BTable,
    BBadge,
    BPagination,
    EditButton,
    DeleteButton,
    DuplicateButton,
    Filters,
    BModal,
    Loading,
    ImportRATModal,
  },
  directives: {
    'b-modal': VBModal,
    Ripple,
  },
  setup() {
    const { route, router } = useRouter()
    const {
      fetchTreatments,
      tableColumns,
      perPage,
      currentPage,
      totalTreatments,
      searchQuery,
      sortBy,
      isSortDirDesc,
      deleteTreatment,
      duplicateTreatment,
      refTreatmentTable,
      treatments,
      isLoading,
      clearFilters,
      clearFiltersDisabled,
      updateFilter,
      fetchAllTreatmentsForExport,
    } = useTreatmentList()

    const { exportToExcel } = useExportRAT()

    const canImport = computed(() => hasPermission('privacy-treatment', 'create'))

    const handleExportExcel = async () => {
      if (!hasPermission('privacy-treatment', 'export')) return
      try {
        // Fetch all treatments respecting current filters
        const allTreatments = await fetchAllTreatmentsForExport()
        exportToExcel(allTreatments)
      } catch (error) {
        console.log(error)
      }
    }

    const handleImportSuccess = () => {
      // Refresh the treatment list after successful import
      fetchTreatments()
    }

    onMounted(async () => {
      fetchTreatments()
    })

    return {
      router,
      fetchTreatments,
      tableColumns,
      perPage,
      currentPage,
      totalTreatments,
      searchQuery,
      sortBy,
      isSortDirDesc,
      deleteTreatment,
      duplicateTreatment,
      refTreatmentTable,
      treatments,
      isLoading,
      clearFilters,
      clearFiltersDisabled,
      canImport,
      hasPermission,
      updateFilter,
      handleExportExcel,
      handleImportSuccess,
    }
  },
}
</script>

<style lang="scss" scoped>
.form-group {
  label {
    font-size: 0.85rem;
    font-weight: 400;
  }
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
